module.exports = __webpack_public_path__ + "img/factory.b7e14601.svg";